import React, { useState, useRef, useEffect } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FaEdit } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const EditDropdown = ({ flowId, onDelete }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleEdit = () => {
    navigate(`/flow-chart/${flowId}`);
    handleClose();
  };
  const handleDelete = () => {
    onDelete(flowId);
    handleClose();
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          bgcolor: "#25D366",
          color: "white",
          "&:hover": { bgcolor: "#22C35E" },
        }}
      >
        <FaEdit />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <AiOutlineEdit size={18} />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <MdDelete size={18} color="#EF4444" />
          </ListItemIcon>
          <ListItemText sx={{ color: "#EF4444" }}>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
export default EditDropdown;